import Vue from 'vue';
import './vendor/modernizr-custom';
import App from './app';
import components from './components';
import filters from './filters';

// CSS
import '../scss/entry.scss';

/**
 * filters
 */
Object.keys(filters).forEach((key) => {
  const value = filters[key];

  Vue.filter(key, value);
});

/**
 * components
 */
Object.keys(components).forEach((key) => {
  const value = components[key];

  Vue.component(key, value);
});

window.app = new App({
  el: '#v-app',
});



// WEBPACK FOOTER //
// ./src/js/entry.js